import { create } from 'zustand';
import { Announcement, NextPrevAnnouncement } from 'types/Announcement';
import { BASE_URL } from 'const/ConstBase';

interface State {
    announcement: Announcement | null;
    nextAnnouncement: NextPrevAnnouncement | null;
    previousAnnouncement: NextPrevAnnouncement | null;
}

const state: State = {
    announcement: null,
    nextAnnouncement: null,
    previousAnnouncement: null,
};

interface Actions {
    fetchAnnouncement: (seq: string | undefined) => void;
}

export const useAnnouncementStore = create<State & Actions>((set) => ({
    ...state,
    fetchAnnouncement: (seq: string | undefined) => {
        fetch(`${BASE_URL}notice/detail/${seq}`, { method: 'GET' }).then(
            async (res) => {
                const response = await res.json();
                const {
                    n_content,
                    n_hit,
                    n_seq,
                    n_title,
                    n_type,
                    reg_date,
                    nextNotice,
                    prevNotice,
                } = response.data;

                set({
                    announcement: {
                        n_content,
                        n_hit,
                        n_seq,
                        n_title,
                        n_type,
                        reg_date,
                        nextNotice,
                        prevNotice,
                    },
                });

                // if announcement is latest, there is no next announcement
                set({
                    nextAnnouncement: nextNotice,
                    previousAnnouncement: prevNotice,
                });
            }
        );
    },
}));
